import React from "react"
import PropTypes from "prop-types"
import ArrowLink from "../components/ArrowLink"

import("../styles/pressCard.scss")

export default function PressCard(props) {
  return (
    <div className="pressCard" key={props.title}>
      <h4
        className="pressTitle"
        dangerouslySetInnerHTML={{ __html: props.title }}
      />
      <ArrowLink
        className="pressButton"
        href={props.slug}
        color="black"
        external={props.external}
      >
        Read More
      </ArrowLink>
    </div>
  )
}

PressCard.propTypes = {
  categories: PropTypes.array,
  title: PropTypes.string,
  slug: PropTypes.string,
  external: PropTypes.bool,
}
